import React from 'react'
import './CollectionsComponent.scss'
import {Zoom} from "react-reveal";
import {AddFilter} from "../../Actions";
import {connect} from "react-redux";
import {withRouter} from "react-router-dom";
import {assetUrl} from "../../serviceApi";

const clock = assetUrl+"images/clock_2.png";

const CollectionsComponent = (props) => {
	const {collection_data} = props
	const  styleLanding = "landing-";

	const getStocksName = (item) => {
		let stocks = [];
		let array = item.politicians && item.politicians.edges?item.politicians.edges:[]

		for(let i = 0;i < array.length;i++){

			stocks[i] = array[i].node.name;
			if(i === array.length-1 && array.length >2){
				let name = stocks.slice(0,2).toString();
				return name + " & more...";
			}
			else if(i === array.length-1  ){
				return stocks.slice(0, array.length).toString();
			}
		}

		return "";
	}
	const filterStock = (item) => {
		let filter_obj = {
			collection:item
		};
		props.applyFilter(filter_obj);
		props.history.push("/all-stocks");
	}
  return (
    <div>
	    <div className={'collection-list-component'}>
		    { collection_data.map((item,index)=>{
			    return(
					// <Zoom key={index}>
						<div className={styleLanding + "collections-card"} onClick={()=>filterStock(item.node)}>
							<div className={styleLanding + "collections-cicle-obj"}/>
							<div className={'d-flex justify-content-center'}>
								{/*<Zoom delay={500}>*/}
									<img alt={'alt'} src={item.icon ? item.icon:clock}
								           className={styleLanding + "collections-card-icon "}/>
								{/*</Zoom>*/}
							</div>
							<p className={styleLanding + "collections-card-title "}>{item.node.name}</p>
							<p className={styleLanding + "collections-card-text"}>{getStocksName(item.node)}</p>
						</div>
					// </Zoom>
			    );
		    })
		    }
	    </div>
    </div>
  )
}

const mapDispatchToProps = dispatch => ({
	applyFilter: data => dispatch(AddFilter(data)),
});

export default connect(null,mapDispatchToProps)(withRouter(CollectionsComponent));
